module.exports = __webpack_public_path__ + "img/fans.c4677101.svg";